import { render, staticRenderFns } from "./UploadTypeSwitch.vue?vue&type=template&id=b7be7eee&"
import script from "./UploadTypeSwitch.vue?vue&type=script&lang=js&"
export * from "./UploadTypeSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports